const LatestUpdateCardSkeleton = () => (
  <div className="rounded-2xl bg-light-green p-4">
    <div className="mb-2 h-6 w-2/3 animate-pulse rounded bg-gray-200" />
    <div className="mb-2 h-4 w-full animate-pulse rounded bg-gray-200" />
    <div className="mb-2 h-4 w-5/6 animate-pulse rounded bg-gray-200" />
    <div className="mt-4 h-3 w-20 animate-pulse rounded bg-gray-200" />
  </div>
);

export const LatestUpdatesSectionSkeleton = () => (
  <div>
    <div className="mb-sh-15 h-8 w-48 animate-pulse rounded bg-gray-200" />
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
      <LatestUpdateCardSkeleton />
      <LatestUpdateCardSkeleton />
      <LatestUpdateCardSkeleton />
    </div>
  </div>
);
